import React from "react";
import { BookOpen, Search, TrendingUp } from "lucide-react";
import useOnScreen from "../../../hooks/useOnScreen";

const values = [
	{
		id: "transparan-dalam-proses",
		icon: Search,
		title: "Transparan dalam Proses",
		description: "Kami percaya progress yang baik datang dari proses belajar yang jujur, jelas, dan konsisten.",
	},
	{
		id: "fokus-pada-progress",
		icon: TrendingUp,
		title: "Fokus pada Progress",
		description: "Setiap siswa berkembang dengan ritmenya masing-masing. Yang penting bukan sempurna, tapi terus bertumbuh.",
	},
	{
		id: "belajar-tanpa-minder",
		icon: BookOpen,
		title: "Belajar tanpa Minder",
		description: "Kami ingin menciptakan lingkungan belajar yang nyaman, suportif, dan bisa diakses lebih banyak pelajar Indonesia.",
	},
];

const Values = () => {
	const [ref, isVisible] = useOnScreen({ threshold: 0.2 });

	return (
			<section ref={ref} id="values" className="st-aboutus-values overflow-x-clip py-14 sm:py-16 lg:py-20">
				<div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
					<div className="grid gap-8 lg:grid-cols-[1.05fr_0.95fr] lg:items-start">
					<div className={isVisible ? "animate__animated animate__fadeInLeft" : ""}>
						<h2 className="st-font-display st-aboutus-values-heading text-[54px] leading-[0.92] sm:text-[70px] lg:text-[80px]">
							<span className="block">
								Our <span className="italic font-normal">Value!</span>
							</span>
							<span className="mt-2 block font-normal text-[32px] sm:text-[36px] lg:text-[48px]">
								<span className="italic">Cara</span> Kami Membangun
							</span>
							<span className="mt-1 block font-semibold text-[32px] sm:text-[36px] lg:text-[48px]">
								ScholarsToday
							</span>
						</h2>
					</div>

					<div className={`lg:pt-6 ${isVisible ? "animate__animated animate__fadeInRight" : ""}`}>
						<p className="st-font-body st-aboutus-values-body max-w-xl text-[17px] leading-[1.7] sm:text-[18px] lg:ml-auto lg:max-w-[48rem] lg:text-right lg:text-[22px]">
							Bukan cuma tentang belajar IELTS, kami ingin menciptakan pengalaman belajar yang lebih suportif, terarah, dan nyaman untuk setiap siswa.
						</p>
					</div>
				</div>

				<div className={`mt-10 grid gap-4 sm:mt-12 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6 ${isVisible ? "animate__animated animate__fadeInUp" : ""}`}>
					{values.map((item) => {
						const Icon = item.icon;

						return (
							<article key={item.id} className="st-aboutus-values-card flex h-full flex-col gap-4 px-5 py-5 sm:px-6 sm:py-6">
								<div className="st-aboutus-values-icon flex h-[72px] w-[72px] items-center justify-center sm:h-[80px] sm:w-[80px]">
									<Icon aria-hidden="true" className="h-9 w-9 sm:h-10 sm:w-10" strokeWidth={2.1} />
								</div>

								<div>
									<h3 className="st-font-body st-aboutus-values-title text-[23px] font-semibold leading-[1.15] sm:text-[24px] lg:text-[26px]">
										{item.title}
									</h3>
									<p className="st-font-body st-aboutus-values-text mt-3 text-[16px] leading-[1.55] sm:text-[17px] lg:text-[18px]">
										{item.description}
									</p>
								</div>
							</article>
						);
					})}
				</div>
				</div>
			</section>
	);
};

export default Values;
